export const yaMetricsId = 51678;
export const yaMetricsAbTestId = `metrika.${yaMetricsId}`;

export const products = {
  CHECKS: "Checks", // Проверки
  MARKET: "Market", // Тракмаркет
  MONITORING: "Monitoring", // АТИ Водитель
  NEWS: "News",
  PASSPORT: "Passport", // Паспорт
  RATING: "Rating", // Рейтинг
  INDEX: "Index", // Индекс ATI.SU
  AVERAGE: "AverageRates", // средние ставки
  ACADEMY: "Academy", // Академия
  INSURANCE: "Insurance", // страхование
  TENDERS: "Tenders", // тендеры
  AUCTIONS: "Auctions", // торги
  LOADS: "LoadsSearch", // поиск грузов
  TRUCKS: "Trucks", // поиск транспорта
  ECOSYSTEM: "Ecosystem", // экосистема
  EXCHANGE: "Exchange", // биржа
  DOC: "Doc", // документы
  BOARDS: "Boards", // Площадки
  PRICES: "Prices", // лицензии
  ORDERS: "Orders", // заказы
  PARTNER: "Partner", // партнерские
  MOBILE: "Mobile", // АТИ Грузы и Транспорт
  NAVIGATION: "Navigation", // Ссылки в шапке и в футере
};


export const metricUrlCodes = {
  SERVICE_API: "header_service_api",
  SERVICE_AUTOMATION: "header_service_automation",
  SERVICE_GPS: "header_service_gps",
  SERVICE_DOCS: "header_service_docs",
  SERVICE_ORDERS: "header_service_orders",
  SERVICE_BOARDS: "header_service_boards",
  SERVICE_TENDERS: "header_service_tenders",
  SERVICE_AUCTION: "header_service_auction",
  SERVICE_PROFITABLE_DESTINATIONS: "header_service_profitable_destinations",
  SERVICE_INDEX: "header_service_index",
  SERVICE_MIDDLE_PRICE: "header_service_middle_price",
  SERVICE_UNLIMITED_CHECK: "header_service_unlimited_check",
  SERVICE_GUARANTEE_PAYMENT: "header_service_guarantee_payment",
  SERVICE_CHECK: "header_service_check",
  SERVICE_TRAFFIC_LIGHT: "header_service_traffic_light",
  SERVICE_MESSENGER: "header_service_messenger",
  SERVICE_FORUMS: "header_service_forums",
  SERVICE_REAL_TRUCK: "header_service_real_truck",
  SERVICE_DISTANCE_CALCULATOR: "header_service_distance_calculator",
  SERVICE_CHAINS: "header_service_chains",
  SERVICE_TIME_SLOTS: "header_service_time_slots",
  SERVICE_ACADEMY: "header_service_academy",
  SERVICE_LOANS: "header_service_loans",
  SERVICE_NEWS: "header_service_news",
  SERVICE_PARTNERSHIP: "header_service_partnership",
  SERVICE_RATING: "header_service_rating",
  SERVICE_INSURANCE: "header_service_insurance",
  SERVICE_TRUCKMARKET: "header_service_truckmarket",
  SERVICE_PARTNERS_OFFERS: "header_service_partners_offers",
  SERVICE_CATALOGS: "header_service_catalogs",
  SERVICE_TICKETS: "header_service_tickets",
  SERVICE_COURIER: "header_service_courier",
  SERVICE_CARGO_MAP: "header_service_cargo_map",

  MAIN_MENU_ADD_LOAD: "header_main_menu_add_load",
  MAIN_MENU_YOUR_LOADS: "header_main_menu_your_loads",
  MAIN_MENU_YOUR_TENDERS: "header_main_menu_your_tenders",
  MAIN_MENU_TENDERS: "header_main_menu_tenders",
  MAIN_MENU_ADD_TENDER: "header_main_menu_add_tender",
  MAIN_MENU_YOUR_ORDERS: "header_main_menu_your_orders",
  MAIN_MENU_OWNERS_REPORTS: "header_main_menu_owners_reports",
  MAIN_MENU_CARRIERS_REPORTS: "header_main_menu_carriers_reports",
  MAIN_MENU_CREATE_BOARD: "header_main_menu_create_board",
  MAIN_MENU_INVITATIONS: "header_main_menu_invitations",
  MAIN_MENU_YOUR_BOARDS: "header_main_menu_your_boards",
  MAIN_MENU_YOU_PARTICIPATE: "header_main_menu_you_participate",
  MAIN_MENU_TRUCKS_SEARCH: "header_main_menu_trucks_search",
  MAIN_MENU_ACTIVE_CARRIERS: "header_main_menu_active_carriers",
  MAIN_MENU_RATING_FOR_CARGO_OWNERS: "header_main_menu_rating_for_cargo_owners",
  MAIN_MENU_RATING_FOR_CARRIERS: "header_main_menu_rating_for_carriers",
  MAIN_MENU_SAFETY_MEMO: "header_main_menu_safety_memo",
  MAIN_MENU_ORGANIZATIONS: "header_main_menu_organizations",
  MAIN_MENU_PARTNERS_AND_CONTRACTS: "header_main_menu_partners_and_contracts",
  MAIN_MENU_YOUR_REQUISITES: "header_main_menu_your_requisites",
  MAIN_MENU_FIRM_LIST: "header_main_menu_firm_list",
  MAIN_MENU_DIRECTION_LISTS: "header_main_menu_direction_lists",
  MAIN_MENU_ADD_TRUCK: "header_main_menu_add_truck",
  MAIN_MENU_YOUR_TRUCKS: "header_main_menu_your_trucks",
  MAIN_MENU_ORDERS_TO_YOU: "header_main_menu_orders_to_you",
  MAIN_MENU_LOADS_EXCHANGE: "header_main_menu_loads_exchange",
  MAIN_MENU_CARGO_CHAINS: "header_main_menu_cargo_chains",
  MAIN_MENU_BOARDS_SEARCH: "header_main_menu_boards_search",
  MAIN_MENU_BOARDS_SEARCH_REDIRECT: "header_main_menu_boards_search_redirect",
  MAIN_MENU_BOARDS: "header_main_menu_boards",
  MAIN_MENU_CATALOGS: "header_main_menu_catalogs",
  MAIN_MENU_DRIVERS: "header_main_menu_drivers",
  MAIN_MENU_GPS: "header_main_menu_gps",
  MAIN_MENU_TIME_SLOTS: "header_main_menu_time_slots",
  MAIN_MENU_CHECKS: "header_main_menu_checks",
  MAIN_MENU_GUARANTEE_PAYMENT: "header_main_menu_guarantee_payment",
  MAIN_MENU_DOCS_INBOX: "header_main_menu_docs_inbox",
  MAIN_MENU_DOCS_AWAITING_DECISION: "header_main_menu_docs_awaiting_decision",
  MAIN_MENU_DOCS_CLOSING: "header_main_menu_docs_closing",
  MAIN_MENU_DOCS_YOUR_COUNTERPARTIES:
    "header_main_menu_docs_your_counterparties",
  MAIN_MENU_DOCS_YOUR_CERTIFICATES: "header_main_menu_docs_your_certificates",
  MAIN_MENU_DOCS_INVOICE: "header_main_menu_docs_invoice",
  MAIN_MENU_DOCS_APPLICATION_AGREEMENT:
    "header_main_menu_docs_application_agreement",
  MAIN_MENU_DOCS_CERTIFICATE_OF_COMPLETION:
    "header_main_menu_docs_certificate_of_completion",
  MAIN_MENU_DOCS_OTHER_DOCUMENT: "header_main_menu_docs_other_document",
  MAIN_MENU_BUTTON_LOADS_SEARCH: "header_main_menu_button_loads_search",
  MAIN_MENU_BUTTON_TRUCKS_SEARCH: "header_main_menu_button_trucks_search",
  MAIN_MENU_BUTTON_CARGO_OWNERS: "header_main_menu_button_cargo_owners",
  MAIN_MENU_BUTTON_CARRIERS: "header_main_menu_button_carriers",
  MAIN_MENU_BUTTON_DOCS: "header_main_menu_button_docs",
  
  MAIN_MENU_BUTTON_STATISTIKA_RYNKA: "header_main_menu_analytics_statistika_rynka",
  MAIN_MENU_BUTTON_SERVISY_DLYA_ANALITIKI: "header_main_menu_analytics_servisy_dlya_analitiki",
  MAIN_MENU_BUTTON_DINAMIKA_RYNKA: "header_main_menu_analytics_dinamika_rynka",
  MAIN_MENU_BUTTON_RYNOK_V_CIFRAH: "header_main_menu_analytics_rynok_v_cifrah",

  // Статистика рынка
  MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_AVGPRICE: "header_main_menu_analytics_statistika_rynka_avgprice",
  MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_CARGOMAP: "header_main_menu_analytics_statistika_rynka_cargomap",
  MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_PROFITDIRECTIONS: "header_main_menu_analytics_statistika_rynka_profitdirections",
  MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_INDEX: "header_main_menu_analytics_statistika_rynka_index",
  
  // Сервисы для аналитики
  MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_AVGPRICE: "header_main_menu_analytics_servisy_dlya_analitiki_avgprice",
  MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_CARGOMAP: "header_main_menu_analytics_servisy_dlya_analitiki_cargomap",
  MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_PROFITDIRECTIONS: "header_main_menu_analytics_servisy_dlya_analitiki_profitdirections",
  MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_INDEX: "header_main_menu_analytics_servisy_dlya_analitiki_index",
  
  // Динамика рынка
  MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_AVGPRICE: "header_main_menu_analytics_dinamika_rynka_avgprice",
  MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_CARGOMAP: "header_main_menu_analytics_dinamika_rynka_cargomap",
  MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_PROFITDIRECTIONS: "header_main_menu_analytics_dinamika_rynka_profitdirections",
  MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_INDEX: "header_main_menu_analytics_dinamika_rynka_index",
  
  // Рынок в цифрах
  MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_AVGPRICE: "header_main_menu_analytics_rynok_v_cifrah_avgprice",
  MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_CARGOMAP: "header_main_menu_analytics_rynok_v_cifrah_cargomap",
  MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_PROFITDIRECTIONS: "header_main_menu_analytics_rynok_v_cifrah_profitdirections",
  MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_INDEX: "header_main_menu_analytics_rynok_v_cifrah_index",
  
  SUB_MENU_SEARCH_LOADS: "header_sub_menu_search_loads",
  SUB_MENU_SEARCH_TRUCKS: "header_sub_menu_search_trucks",
  SUB_MENU_ADD_LOAD: "header_sub_menu_add_load",
  SUB_MENU_ADD_TRUCK: "header_sub_menu_add_truck",
  SUB_MENU_ORDERS: "header_sub_menu_orders",
  SUB_MENU_YOUR_ORDERS: "header_sub_menu_your_orders",
  SUB_MENU_ORDERS_TO_YOU: "header_sub_menu_orders_to_you",
  SUB_MENU_STARS: "header_sub_menu_stars",
  SUB_MENU_YOUR_LOADS: "header_sub_menu_your_loads",
  SUB_MENU_YOUR_TRUCKS: "header_sub_menu_your_trucks",

  BURGER_ADD_TRUCK: "header_burger_add_truck",
  BURGER_ADD_CARGO: "header_burger_add_cargo",

  BOTTOM_MENU_YOUR_ORDERS: "header_bottom_menu_your_orders",
  BOTTOM_MENU_ORDERS_TO_YOU: "header_bottom_menu_orders_to_you",
  BOTTOM_MENU_ORDERS_TO_DRIVER: "header_bottom_menu_orders_to_driver",
  BOTTOM_MENU_YOUR_TRUCKS: "header_bottom_menu_your_trucks",
  BOTTOM_MENU_YOUR_LOAD: "header_bottom_menu_your_load",
  BOTTOM_MENU_ORDERS: "header_bottom_menu_orders",

  FOOTER_ADD_TRUCK: "header_footer_add_truck",
  FOOTER_ADD_TENDER: "header_footer_add_tender",
  FOOTER_ADD_TRUCK_NEW: "header_footer_add_truck_new",
  FOOTER_ADD_ORDER: "header_footer_add_order",
  FOOTER_BILLING: "header_footer_billing",
  FOOTER_CREATE_BOARD: "header_footer_create_board",
  FOOTER_ADD_LOAD: "header_footer_add_load",

  COOKIE_BANNER_HELP: "header_cookie_banner_help",

  LOGO: "header_logo",

  NOTIFICATION_SETTINGS: "header_notification_settings",

  ONLINE_LOANS: "header_online_loans",
  CARGO_OWNER_BUTTON: "header_cargo_owner_button", // !

  FREE_ACCESS_BILLING: "header_free_access_billing",
  FREE_ACCESS_MORE: "header_free_access_more",
  FREE_ACCESS_SELECT: "header_free_access_select",

  LICENSES_BLOCK: "header_licenses_block",

  GUARANTEED_PAYMENT_INVOICE: "header_guaranteed_payment_invoice",
  GUARANTEED_PAYMENT_KVITANCIYA: "header_guaranteed_payment_kvitanciya",
  GUARANTEED_PAYMENT_AGREEMENT: "header_guaranteed_payment_agreement",

  LICENSE_PAID_EXTEND: "header_license_paid_extend",
  LICENSE_PAID_ADD: "header_license_paid_add",

  LOGOUT: "header_logout",

  RECURRENT_PAYMENT: "header_recurrent_payment",

  RECURRENT_PAYMENT_ERROR: "header_recurrent_payment_error",

  UNLIMITED_LICENSES: "header_unlimited_licenses",

  SEARCH_RESTRICTION_BILLING: "header_search_restriction_billing",

  FIRM_NAME: "header_firm_name",

  EXTENSION_SEARCH: "header_extension_search",
  CHAT_BUTTON: "header_button_chat",

  PROFILE_CABINET_CONTACT_EDIT: "header_profile_cabinet_contact_edit",
  PROFILE_CABINET_OFFICE: "header_profile_cabinet_office",
  PROFILE_BALANCE: "header_profile_balance",
  PROFILE_STARS: "header_profile_stars",
};